import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve led multiple transformation initiatives across operations, cards, and
                digital channels.What operational areas do you believe offer the biggest ROI when
                digitized, and how do you prioritize them during transformation planning?
              </strong>
            </h5>

            <h5 className="text-white">
              The biggest ROI in digitization often comes from automating high-volume,
              low-complexity processes—particularly in areas like customer onboarding, client
              payments, and reconciliations. These functions are ripe for intelligent automation and
              machine learning, significantly reducing operational costs and error rates while
              enhancing speed and transparency.
              <br />
              <br />
              Prioritization begins with a cost-to-serve and value-to-customer matrix. We assess
              each function’s impact on customer experience and internal cost. High-friction,
              high-cost processes that directly affect customer touchpoints (like card issuance
              delays or payment exceptions) are prioritized
              <br />
              <br />
              we prioritize based on a three-lens approach:
              <br />
              <ul>
                <li>Customer impact – Will this reduce friction or improve speed?</li>
                <li>Cost and complexity – How much effort vs. value does it take to automate?</li>
                <li>Scalability – Can this support future digital services?</li>
              </ul>
              <br />
              By applying these filters, we avoid the trap of chasing shiny technologies and focus
              on what truly transforms the operating model.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Managing diverse functions like custody, loyalty, and payments requires tight
                orchestration. How do you streamline such complex, multi-functional operations while
                ensuring regulatory compliance and customer satisfaction?
              </strong>
            </h5>
            <h5 className="text-white">
              When overseeing diverse functions like custody, loyalty, and payments, no single
              person can be deeply involved in every detail — and that’s where delegation and clear
              accountability become critical. My role is to set the strategic direction, establish a
              strong governance model, and ensure that the right leaders are empowered to own their
              domains, while still staying aligned to the bank’s broader goals.
              <br />
              <br />
              I start by appointing or selecting capable leads in each function — people who not
              only have subject matter expertise, but who understand the importance of working
              cross-functionally. I make it clear that they are accountable not just for their
              team’s performance, but for how their work contributes to customer satisfaction, risk
              management, and long-term value creation.
              <br />
              <br />
              To tie it all together, I create a structured operating rhythm — typically through
              layered governance: strategic steering committees, operational review meetings, and
              issue escalation pathways. This gives us both visibility and agility. I stay focused
              on the big picture: Are we moving in the right direction? Are we meeting our customer
              commitments? Are we staying ahead of regulatory expectations?
              <br />
              <br />
              I also reinforce a culture of ownership and transparency. Each function has clearly
              defined KPIs — not only operational metrics, but also customer and compliance
              indicators. When everyone understands what they’re accountable for, and how their
              outcomes affect others, coordination becomes much smoother.
              <br />
              <br />
              Lastly, I keep a close eye on how all these moving parts come together from a customer
              and regulatory standpoint. Whether we’re launching new payments feature or enhancing
              custody reporting, I make sure the strategic intent — better experience, tighter
              controls, long-term scalability — isn’t lost in execution.
              <br />
              <br />
              So, for me, managing complex operations isn’t about controlling every detail; it’s
              about setting the direction, empowering the right people, and creating the structure
              that keeps us aligned, compliant, and customer-focused.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-In a fast-moving digital banking ecosystem, agility is critical. What are your key
                strategies for ensuring operational resilience and adaptability as customer
                expectations and technologies evolve?
              </strong>
            </h5>
            <h5 className="text-white">
              I design processes with adaptability in mind. That means simplifying workflows,
              reducing dependencies, and making sure we’re not locked into rigid systems. Wherever
              possible, we standardize and digitize — but we also leave room for flexibility so that
              we can pivot quickly when needed, whether it’s a new product launch or a regulatory
              shift.
              <br />
              <br />
              Also, I put a strong emphasis on developing our people. Technology moves fast, but
              it’s our teams who drive change. I’ve led programs where we cross-train staff, embed a
              continuous learning mindset, and build operational capabilities that can scale and
              shift with the business. That’s been critical, especially when unexpected events test
              the organization’s resilience.
              <br />
              <br />
              Finally, I believe in fostering a culture of responsiveness and collaboration. I keep
              communication lines open across departments and encourage teams to surface issues
              early, test ideas quickly, and learn from both successes and setbacks. We use data and
              feedback to guide decisions, but we also empower teams to act decisively — agility
              comes from trust as much as process.
              <br />
              <br />
              Ultimately, operational resilience isn’t just about withstanding shocks — it’s about
              being ready to adapt, improve, and lead through change. In my experience, the most
              resilient operations teams are the ones that stay connected to the customer, grounded,
              and open to what’s next.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You’re known for balancing strategic vision with hands-on execution. How do you
                maintain alignment between high-level transformation roadmaps and daily operational
                execution across cross-functional teams?
              </strong>
            </h5>
            <h5 className="text-white">
              First, I make sure that the strategic roadmap is broken down into specific, measurable
              objectives for each department. It’s not enough to say we’re improving efficiency or
              digitizing processes — we define exactly what that means for each team, whether it’s
              reducing manual touchpoints, cutting processing time, or improving data quality. This
              gives everyone a clear line of sight from their daily work to the overall
              transformation goals.
              <br />
              <br />
              Second, I put strong governance in place. That means having regular cross-functional
              working groups — not just high-level steering committees, but hands-on forums where
              operations, IT, compliance, and business teams can align, raise challenges early, and
              keep momentum. It keeps everyone connected and accountable.
              <br />
              <br />I also believe in real-time feedback loops. I’ve led programs where dashboards,
              SLA tracking, and even staff feedback were used to regularly assess progress and
              adjust course where needed. This helps ensure we’re not just following a roadmap, but
              actively shaping it based on what’s working on the ground.
              <br />
              <br />
              Lastly, I stay close to the teams. It’s important to walk the floor, understand the
              blockers, and make sure people feel heard during what can be a demanding change
              process. That visibility and engagement go a long way in keeping execution aligned
              with strategy.
              <br />
              <br />
              At the end of the day, transformation doesn’t succeed because of the plan on paper —
              it succeeds because people at every level understand it, own it, and can see their
              role in making it happen.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You emphasize a customer-first mindset in back-office and technical operations.
                How do you embed customer-centric thinking into traditionally non-customer-facing
                departments like operations or processing?
              </strong>
            </h5>
            <h5 className="text-white">
              I've consistently emphasized that even in Operations or non-customer-facing roles, the
              end customer must be at the heart of everything we do. Embedding a customer-centric
              mindset in these departments involves three key strategies: culture, processes, and
              metrics.
              <br />
              <br />
              1. Instilling a Customer-Centric Culture: <br />
              I start by aligning the team's mindset with the understanding that every internal
              process ultimately impacts the external customer. This means regularly sharing
              frontline feedback with operations teams, organizing cross-functional workshops with
              customer-facing colleagues, and even inviting operations staff to join branch visits
              or customer service calls. This breaks silos and creates empathy and accountability.
              <br />
              <br />
              2. Designing Processes Around Customer Impact: <br />
              Instead of designing workflows for internal convenience, we ask: What will this look
              like from the customer’s perspective? For example, in one bank, we redesigned a KYC
              remediation process not just for compliance, but to reduce customer disruptions. We
              consolidated document requests and aligned timelines with customer cycles, leading to
              smoother interactions and better feedback scores — even though the work was done in
              the back office.
              <br />
              <br />
              3. Measuring What Matters: <br />
              I embedded customer impact into operational KPIs. It’s not enough to measure
              processing speed or accuracy — we also track downstream effects like complaint rates,
              SLA breaches affecting customer-facing teams, or turnaround time on client-sensitive
              requests. When operations see how their work affects satisfaction scores or NPS,
              priorities naturally shift.
              <br />
              <br />
              Ultimately, the goal is to ensure that every function in the bank, whether
              customer-facing or not, sees themselves as part of the customer journey. That mindset
              doesn’t just improve service — it drives operational excellence and competitive
              advantage.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
